import React, { useState, useLayoutEffect, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { Input } from '../../components';
import { icons } from '../../assets';
import * as s from './styled-register';

const Senha = ({
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
}) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const { colors } = useContext(ThemeContext);

  useLayoutEffect(() => {
    updateSize();
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  const updateSize = () => setScreenWidth(window.innerWidth);

  const renderPasswordWarning = () => (
    <s.PasswordWarning>
      <s.Icon
        src={icons.RegisterRight}
        width="47px"
        height="60px"
        margin="0 20px"
      />
      <s.Label bold size="12px" color={colors.darkblue}>
        A senha deve conter número e letras
      </s.Label>
    </s.PasswordWarning>
  );

  return (
    <s.FormContainer url="RegisterOpaqueLeft.svg">
      <div id="content">
        <s.Title>Cadastrar</s.Title>

        <s.Wrapper input>
          <s.Label size="13px" color={colors.darkblue} bold>
            Senha
          </s.Label>
          <Input
            src={icons.PasswordIcon}
            placeholder="Digite sua senha (mín. 8 dígitos)"
            width="500px"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            noPadding
          />
          {screenWidth > 1180 && renderPasswordWarning()}
        </s.Wrapper>
        <s.Wrapper input>
          <s.Label size="13px" color={colors.darkblue} bold>
            Confirme sua senha
          </s.Label>
          <Input
            src={icons.PasswordIcon}
            placeholder="Digite novamente sua senha"
            width="500px"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            type="password"
            noPadding
          />
        </s.Wrapper>
        {screenWidth < 1180 && renderPasswordWarning()}
      </div>
    </s.FormContainer>
  );
};

export default Senha;
